import React, { memo } from 'react';
import { AuthorisationConsumer, RequestProvider } from '@shootsta/common-react';
import { updateVideoAtomicApi } from '../../../api';
import RenameConfirmationModalComponent from '../components/RenameConfirmationModal';

type RenameConfirmationModalProps = {
  video?: Video;
  visible: boolean;
  onConfirmation: any;
  onClose: any;
};

function RenameConfirmationModal(props: RenameConfirmationModalProps) {
  return (
    <AuthorisationConsumer requiresOrganisation>
      {({ selectedOrganisation: { name } }) => (
        <RequestProvider
          requests={{
            updateVideoAtomic: updateVideoAtomicApi
          }}
        >
          {(requests) => (
            <RenameConfirmationModalComponent
              organisationName={name}
              {...requests}
              {...props}
            />
          )}
        </RequestProvider>
      )}
    </AuthorisationConsumer>
  );
}

export default memo<RenameConfirmationModalProps>(RenameConfirmationModal);
